module.exports = __webpack_public_path__ + "static/media/holobrain-original.db4025dd.jpg";